import React, { useContext, Fragment, useState, useRef } from 'react';
import { withStyles, Divider } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';
import RightArrowIcon from '../../../asset/img/ico_lb_right_arrow.svg';
import ValidatePhone from '../../modal/ValidatePhone';

const styles = (theme) => ({
  root: {
    display: 'flex',
    letterSpacing: '-0.5px',
  },
  divider: {
    height: '0.0625rem',
    backgroundColor: theme.color.divider.grey,
    width: '100%',
  },

  listBox: {
    width: '100%',
    borderRadius: '0.625rem',
    boxShadow: '0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1)',
    margin: '0 1rem 1rem 1rem',
    backgroundColor: theme.color.button.background_white,
    // padding: "0 16px",
  },
  buttonBox: {
    width: '100%',
    height: '5rem',
    display: 'flex',
    padding: '1.25rem',
    backgroundColor: theme.color.button.background_white,
    // backgroundColor: "#da0f47",
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '0',
    textAlign: 'left',
    cursor: 'pointer',

    // boxShadow: "0px 12px 12px rgba(194, 194, 194, 0.58)",
    // fontWeight: "300",
    // padding: "9px 20px",
    // minHeight: "2.875rem",
    // justifyContent: "center",
    // alignItems: "center"
  },
  buttonBoxRoundTop: {
    borderRadius: '0.625rem 0.625rem 0 0',
  },
  buttonBoxRoundBottom: {
    borderRadius: '0 0 0.625rem 0.625rem',
  },
  buttonStrBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  buttonStrText: {
    fontSize: theme.font.size12,
    color: theme.color.message.grey,
    margin: '0 0 0.125rem 0',
    wordBreak: 'keep-all',
  },
  buttonStrTitle: {
    fontSize: theme.font.size15,
    color: theme.color.message.color,
    fontWeight: 'bold',
  },
  buttonIcon: {
    minWidth: '1rem',
    minHeight: '1rem',
  },

  button: {
    minHeight: '2.5rem',
    textAlign: 'center',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0',
    margin: '0',
    flex: 1,
    backgroundColor: '#ea1917', //"#da0f47;",
    textTransform: 'none',
    // outline: '0 none',
    border: '0',
    // borderRadius: "0px 0px 12px 12px",
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '2.5rem',
    color: '#fff',
    padding: '0 1.25rem',
    fontSize: theme.font.size14,
    textAlign: 'center',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    padding: ' 0.875rem',
    position: 'fixed',
    bottom: '1.375rem',
    placeContent: 'center',
  },
  modalButton: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    // border: "solid 1px #da0f47",
    // backgroundColor: "#fff",
    // margin: "0px 4px",
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    // color: "#da0f47",
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0',
  },
  modalGridContainer: {},
  modalGridItemLabel: {
    padding: '0.75rem 0.875rem 0rem 0.875rem',
  },
  modalGridItem: {
    padding: '0.75rem 0.875rem',
  },
  modalLabel: {
    // minHeight: "20px",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', // "#da0f47"
    },
  },
  modalField: {
    // paddingTop: "12px",
    // "& input":{
    //   borderRadius: "6px",
    //   width: "100%",
    //   height: "46px",
    //   border: "solid 1px #929292",
    //   padding: "13px 16px"
    // }
  },
  inputNormal: {
    borderRadius: '0.375rem',
    width: '100%',
    height: '2.875rem',
    border: 'solid 1px #929292',
    padding: '0.8125rem 1rem',
  },

  modalPlainBtn: {
    minHeight: '2.875rem',
    borderRadius: '0.375rem',
    // border: "solid 1px #000",
    // backgroundColor: "#fff",
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    // color: "#000",
  },
  modalInnerItem: {
    padding: '0',
    paddingRight: '0.5rem',
  },
  modalInnerItemLast: {
    paddingRight: '0',
  },
  time: {
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.42',
    letterSpacing: 'normal',
    // textAlign: "center",
    color: '#ff3723',
    position: 'absolute',
    paddingTop: '0.875rem',
    marginLeft: '-2.5rem',
  },
  redButton: {
    color: theme.color.button.rbut_text,
    backgroundColor: theme.color.button.rbut_bg,
    border: '0',
  },
  redButtonDisable: {
    color: theme.color.button.rbut_text_disable,
    backgroundColor: theme.color.button.rbut_bg_disable,
    border: '0',
  },
  whiteButton: {
    color: theme.color.button.wbut_text,
    backgroundColor: theme.color.button.wbut_bg,
    border: `solid 0.0625rem ${theme.color.button.wbut_border}`,
  },
  whiteButtonDisable: {
    color: theme.color.button.wbut_text_disable,
    backgroundColor: theme.color.button.wbut_bg_disable,
    border: `solid 0.0625rem ${theme.color.button.wbut_border_disable}`,
  },
  normalButton: {
    color: theme.color.text_color.black,
    backgroundColor: theme.color.button.background_white,
    border: `solid 0.0625rem ${theme.color.text_color.black}`,
  },
  normalButtonDisable: {
    color: theme.color.button.text_red_disable,
    backgroundColor: theme.color.button.background_white_disable,
    border: `solid 0.0625rem ${theme.color.button.background_red_disable}`,
  },
  inputDisable: {
    backgroundColor: theme.color.input.modal_disable,
    border: '0',
  },
  errorPopup: {
    position: 'absolute',
    borderRadius: '6px',
    boxShadow: '0.25rem 0.25rem 1.5rem 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    width: '100%',
    margin: '0 1rem',
  },
});

function LB(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const [phoneModalOpen, setPhoneModalOpen] = useState(false);

  const handleClick = (link) => {
    if (link.login_type === 'phonenum') {
      if (link.event_action) {
        context.log(context, 'clicks', link.event_action);
      }
      openPhoneModal();
    } else if (link.login_type === 'lg_member') {
      openLink(context, link.type, link.url, link?.event_action, true);
    } else {
      console.log('err');
    }
  };

  const openPhoneModal = () => {
    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    setPhoneModalOpen(true);
    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].setAttribute('aria-hidden', 'true');
    }
  };
  const closePhoneModal = () => {
    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    setPhoneModalOpen(false);
    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
  };

  let linkArray = [];
  if (Array.isArray(data.links)) {
    linkArray = data.links;
  } else {
    linkArray = [
      {
        login_type: 'lg_member',
        url: 'https://devmember.lge.co.kr/auth/empLogin.do?client_id=lge-main-integration&redirect_uri=http%3A%2F%2Fst.lgechat.com%2Fkr%2Freservation%2Fservices%2Fmembers.html&state=lgcom%3A4AXcc9eIW0x2BVHirgD8mi%3A4AXcc9eIW0x2BVHirgD8mi%3A1679306754%3Adev&chatbot=y',
        type: 'external', //link open시 *external : 외부 browser에서 open, *inapp : app에서 inapp browser로 open
        title: '회원 로그인',
        text: '회원이신가요? 맟춤상담을 원하신다면',
      },
      {
        login_type: 'phonenum', // 점유인증
        url: '', // phonenum type은 필요없음
        type: '', // phonenum type은 필요없음
        title: '휴대전화 인증',
        text: '로그인 없이 주문/배송조회를 한 번에',
      },
    ];
  }

  return (
    <Fragment>
      <div className={classes.root}>
        <div className={classes.listBox}>
          {linkArray.map((linkData, linkIndex) => {
            return (
              <Fragment key={`lb_buttong_frag_${linkIndex}`}>
                <Divider
                  className={classes.divider}
                  // orientation="vertical"
                  hidden={linkIndex === 0}
                  disabled
                />
                <button
                  key={`lb_${linkIndex}`}
                  type="button"
                  className={[
                    classes.buttonBox,
                    linkIndex === 0 && classes.buttonBoxRoundTop,
                    linkIndex === linkArray.length - 1 && classes.buttonBoxRoundBottom,
                  ].join(' ')}
                  disabled={context.conversationEnd}
                  onClick={() => handleClick(linkData)}
                  title={`${
                    linkData.type.toLowerCase() === 'external'
                      ? context.string.aria.external + ','
                      : ''
                  } ${linkData.title}`}
                >
                  <div className={classes.buttonStrBox}>
                    <div className={classes.buttonStrText}>{linkData.text}</div>
                    <div className={classes.buttonStrTitle}>{linkData.title}</div>
                  </div>
                  <img className={classes.buttonIcon} src={RightArrowIcon} />
                </button>
              </Fragment>
            );
          })}
        </div>
      </div>
      <ValidatePhone
        data={data}
        modalOpen={phoneModalOpen}
        modalClose={closePhoneModal}
      />
    </Fragment>
  );
}
export default withStyles(styles)(LB);
